import axios, { setBearer } from "./axios";
import { GiftcardClaim } from "./types";

const requestOtp = (phone: string): Promise<void> =>
    axios.post("core/phone/otp", { phone }).then(() => undefined),
  verifyOtp = async (phone: string, code: string): Promise<void> => {
    const result = await axios.post("core/phone/otp/verify", { phone, code });
    setBearer(result.data.data.access_token);
  },
  claimGiftcard = (): Promise<GiftcardClaim> =>
    axios.post("core/phone/giftcard").then((result) => result.data.data);

export const phoneService = { requestOtp, verifyOtp, claimGiftcard };
